import * as users from '../actionTypes/Users/Users'
import Api from '../Api'
import { Config } from '../Config'
import { CommonConstants } from '../Constants'
import AuthenticationService from '../components/Security/AuthenticationService'
const _ = require('underscore')

function getUsersSuccess (stores) {
  return {
    type: users.GET_USERS,
    usersDetails: stores
  }
}
function getActivitySuccess (activity) {
  return {
    type: users.GET_ACTIVITY,
    activity: activity
  }
}

// This function returns list of users
export const getUsers = (callback) => {
  const authService = new AuthenticationService(Config.authBaseUrl)
  let url
  if (authService.isAdmin()) {
    url = Config.apiBaseUrl + CommonConstants.apiUrls.getUsers + '?isAdmin=1'
  } else {
    url = Config.apiBaseUrl + CommonConstants.apiUrls.getUsers + '?isAdmin=0'
  }
  return (dispatch, getState) => {
    const api = new Api()
    const state = getState()
    // appending parameters as query params
    if (state.users.paginationParams && authService.isAdmin()) {
      url = url + '&psize=' + state.users.paginationParams.pageSize + '&pno=' + state.users.paginationParams.pageNumber
    } else {
      url = url + '&pno=0'
    }
    if (state.users.searchParams && authService.isAdmin()) {
      url = url + '&criteria=' + (state.users.searchParams.criteria ? encodeURIComponent(state.users.searchParams.criteria) : '') + '&filter=' + (state.users.searchParams.filter ? state.users.searchParams.filter : '')
    }

    if (state.users.sortParams) {
      url = url + '&Sortby=' + (state.users.sortParams.sortBy ? state.users.sortParams.sortBy : '') + '&sortType=' + (state.users.sortParams.sortType ? state.users.sortParams.sortType : '')
    }

    if (state.users.uuid || authService.isMasquerade()) {
      url += '&uuid=' + authService.getUUID()
    }

    api.getData(url, data => {
      let users = data
      let userDetails = authService.getProfile()
      users.usersList = (!authService.isAdmin() ? _.filter(data.usersList, function (user) { return user.User_UID !== userDetails.User_UID }) : data.usersList)
      dispatch(getUsersSuccess(users))
      callback()
    })
  }
}

// This function returns list of activities
export const getActivity = (uuid, callback) => {
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.getAudit + '?uuId=' + uuid
  return (dispatch, getState) => {
    const api = new Api()
    const state = getState()
    if (state.users.sortParamsActivity) {
      url = url + '&sortBy=' + (state.users.sortParamsActivity.sortBy ? state.users.sortParamsActivity.sortBy : '') + '&sortType=' + (state.users.sortParamsActivity.sortType ? state.users.sortParamsActivity.sortType : '')
    }

    api.getData(url, data => {
      let activity = data.data
      dispatch(getActivitySuccess(activity))
      callback()
    })
  }
}

// save new user
export const SaveUsers = (data, callback) => {
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.createUser
  return (dispatch, getState) => {
    const api = new Api()
    api.postData(url, data, result => {
      dispatch(getUsersSuccess(data))
      callback(null, result)
    }, error => {
      dispatch(getUsersSuccess(data))
      callback(error)
    })
  }
}

// set sort parametes for user listing page in redux
export const sortActivity = (sortParams) => {
  return {
    type: users.SET_SORT_PARAMS_ACTIVITY,
    sortParams: sortParams
  }
}

// set sort parametes for user listing page in redux
export const sortUsers = (sortParams) => {
  return {
    type: users.SET_SORT_PARAMS_USERS,
    sortParams: sortParams
  }
}

// set pagination parametes for user listing page in redux
export const paginationUsers = (paginationParams) => {
  return {
    type: users.SET_PAGINATION_PARAMS_USERS,
    paginationParams: paginationParams
  }
}

// set search parametes for user listing page in redux
export const setSearchParams = (searchParams) => {
  return {
    type: users.SET_SEARCH_PARAMS_USERS,
    searchParams: searchParams
  }
}

export const setUUID = (uuid) => {
  return {
    type: users.SET_USERS_UUID,
    uuid: uuid
  }
}
// Forgot password post call
export const forgotPassword = (data, callback) => {
  this.api = new Api()
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.forgotPassword
  return (dispatch, getState) => {
    const api = new Api()
    api.postData(url, data, result => {
      callback(result)
    })
  }
}
// Reset password expiry post call
export const checkResetPasswordLinkExpiry = (data, callback) => {
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.checkResetPasswordLinkExpiry
  return (dispatch, getState) => {
    const api = new Api()
    api.postData(url, data, result => {
      callback(result)
    })
  }
}
// Reset password post call
export const resetPassword = (data, callback) => {
  let url = Config.apiBaseUrl + CommonConstants.apiUrls.resetPassword
  return (dispatch, getState) => {
    const api = new Api()
    api.postData(url, data, result => {
      callback(result)
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/users.js